var map = {
	"./main-img-2-dark.png": 7488,
	"./main-img-2.png": 8580,
	"./main-img-dark.png": 2867,
	"./main-img-pc-dark.png": 2095,
	"./main-img-pc.png": 963,
	"./main-img.png": 3780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5567;